import React from 'react'
import styles from './PopupWithdraw.module.scss'
import { Modal } from 'components/Modal/Modal'
import { Icon } from 'components/Icon/Icon'
import { Button } from 'components/Button/Button'
import classnames from 'classnames'
import { PATRON_STATUS } from '../consts'

type Props = {
    onClose: () => void;
}

export function PopupWithdraw(props: Props) {
    function onSubmit(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault()
    }

    // test data for status
    const STATUS_MOCK_DATA = PATRON_STATUS.UNCLAIMED

    const statusClassNames = classnames({
        [styles['status']]: true,
        [styles['status_green']]: STATUS_MOCK_DATA === PATRON_STATUS.WITHDREW,
        [styles['status_blue']]: STATUS_MOCK_DATA === PATRON_STATUS.CLAIMED,
        [styles['status_orange']]: STATUS_MOCK_DATA === PATRON_STATUS.UNCLAIMED,
    })

    return (
        <Modal onClose={props.onClose}>
            <form className={styles['wrapper']} onSubmit={onSubmit}>
                <div className={styles['saving']}>
                    <Icon name='withdraw' />
                </div>
                <div className={styles['title']}>
                    <b>USDC 13000 </b>deposit from <b>Marcus Anderson</b>
                </div>
                <div>
                    <div className={styles['content']}>
                        <div className={styles['row']}>
                            <span>Recepient</span>
                            <span>Aleksandr F.</span>
                        </div>
                        <div className={styles['row']}>
                            <span>Deposit</span>
                            <span>$300</span>
                        </div>
                        <div className={styles['row']}>
                            <span>Available for recepient</span>
                            <span>$17</span>
                        </div>
                        <div className={styles['row']}>
                            <span>Status</span>
                            <span className={statusClassNames}>UNCLAIMED</span>
                        </div>
                        <span className={styles['description']}>
                            Do you really want to withdraw a deposit?
                            <br />
                            The recipient will no longer be able to receive your help. But he will be able to withdraw the already accumulated interest ($17)</span>
                    </div>
                </div>
                <div className={styles['button']}>
                    <Button size='m' type='dark'>
                        Withdraw
                    </Button>
                    <Button size='m' type='dark'>
                        Change amount
                    </Button>
                    <Button
                        size='m'
                        type='border'
                        stretch={false}
                        onClick={props.onClose}>
                        Cancel
                    </Button>

                </div>
            </form>
        </Modal>
    )
}

